import React from 'react';
import './ProcessPage.css';

import { Heading, PageTitle, ProcessStep } from '../../../components';
import { process } from '../../../constants';


const ProcessPage = () => { 

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Process'} page={'Process'} />

      <section className='process'>
  
        {/* Section heading */}
        <Heading title={'Our Approach'} subTitle={'Our Approach'} />

        <div className='box-container'>    
          {// Map through the processContent array and render process items
            process.map((step) => { 

              return ( 
                <ProcessStep
                  key={step.id}
                  id={step.id}
                  image={step.image}
                  title={step.title}
                  content={step.content}
                />
              )
            })
          }
        </div>

      </section>

    </>
  )
}

export default ProcessPage;